/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useMemo, useCallback } from 'react';

import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal, Popover } from 'antd';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import queryString from 'query-string';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { ResponsiveComponent, generateQueryString } from '../../utils/functions';
import Sidebar from '../../components/Sidebar';
import { plusicon, refreshicon } from '../../components/imagepath';
import Header from '../../components/Header';
import { matchPermissions } from '../../utils/Permission';
import AdvancedTable from '../../components/AdvancedTable';
import { ActionGetAllCouponList, ActionDeleteCoupon } from '../../store/Actions/CouponAction';
const { confirm } = Modal;

const CouponManagement = () => {
  const { loader, couponList } = useSelector(state => state?.CouponManagement);
  const { userDetails } = useSelector(state => state?.auth);
  const [showArrow, setShowArrow] = useState(true);
  const [arrowAtCenter, setArrowAtCenter] = useState(false);
  const params = queryString.parse(location.search);
  const pageSize = parseInt(params?.perPage) || 10;
  const dispatch = useDispatch();
  const Size = ResponsiveComponent();
  const navigate = useNavigate();

  const mergedArrow = useMemo(() => {
    if (arrowAtCenter)
      return {
        pointAtCenter: true,
      };
    return showArrow;
  }, [showArrow, arrowAtCenter]);

  const matchPermissionsForUser = matchPermissions(userDetails);
  const canUpdate = matchPermissionsForUser('coupon.update');
  const canDelete = matchPermissionsForUser('coupon.delete');
  const canCreate = matchPermissionsForUser('coupon.create');
  const canHistoryView = matchPermissionsForUser('coupon.history');
  const content = item => (
    <div className="">
      {canUpdate && (
        <Button className="m-2" onClick={() => EditList(item?._id || item?.id)}>
          Edit
        </Button>
      )}
      {canHistoryView && (
        <Button
          className="m-2"
          onClick={() => navigate(`/coupon-management/history/${item?.code}`)}
        // type="default"
        >
          History
        </Button>
      )}
      {canDelete && <Button onClick={() => showDeleteConfirm(item)}>Delete</Button>}
    </div>
  );

  // Define columns for AdvancedTable
  const columns = [
    {
      id: 'sr',
      name: 'Sr',
      selector: 'sr',
      sortable: false,
      cell: (record, index) => {
        const currentPage = parseInt(params?.page) || 1;
        const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
        return <span>{calculatedIndex}</span>;
      },
    },
    {
      id: 'code',
      name: 'Code',
      selector: 'code',
      sortable: true,
    },
    {
      id: 'couponQuantity',
      name: 'Coupon Quantity',
      selector: 'couponQuantity',
      sortable: true,
    },
    {
      id: 'bookingFor',
      name: 'Service Type',
      selector: 'bookingFor',
      sortable: true,
    },
    {
      id: 'platformType',
      name: 'Platform Type',
      selector: 'platformType',
      sortable: true,
    },
    {
      id: 'type',
      name: 'Type',
      selector: 'type',
      sortable: true,
    },
    {
      id: 'value',
      name: 'Value',
      selector: 'value',
      sortable: true,
    },
    {
      id: 'startDate',
      name: 'Validity Start',
      selector: 'startDate',
      sortable: true,
    },
    {
      id: 'expiryDate',
      name: 'Validity End',
      selector: 'expiryDate',
      sortable: true,
    },
    // {
    //   id: 'totalUsageLimit',
    //   name: 'Total Usage Limit',
    //   selector: 'totalUsageLimit',
    //   sortable: true,
    // },
    {
      id: 'personUsageLimit',
      name: 'Per User Usage Limit',
      selector: 'personUsageLimit',
      sortable: true,
    },
    // {
    //   id: 'perPersonOneTime',
    //   name: 'Per Person One Time',
    //   selector: 'perPersonOneTime',
    //   sortable: true,
    //   cell: record => <span>{record.perPersonOneTime ? 'Yes' : 'No'}</span>,
    // },
  ];

  // Add actions column only if user has update or delete permissions
  if (canUpdate || canDelete) {
    columns.push({
      id: 'actions',
      name: 'Action',
      selector: 'id',
      sortable: false,
      cell: (record) => (
        <Popover
          placement="left"
          title={record.title}
          content={() => content(record)}
          arrow={mergedArrow}
        >
          <Button type="dashed">• • •</Button>
        </Popover>
      ),
    });
  }


  const handleSearch1 = searchTerm => {
    var newp = params;
    newp.page = searchTerm;
    window.location.href = window.location.pathname + '?' + queryString.stringify(newp);
  };

  const EditList = searchTerm => {
    window.location.href = `/coupon-management/add-coupon?update=true&&id=${searchTerm}&&page=${parseInt(params.page)}`;
  };

  const showDeleteConfirm = item => {
    confirm({
      title: `Are you sure delete this ${item?.id}?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      zIndex: 1200,
      centered: true,
      onOk() {
        dispatch(
          ActionDeleteCoupon({ Query: '/' + (item?._id || item?.id) }, Res => {
            if (Res === 200) {
              window.location.reload();
            }
          })
        );
      },
      onCancel() {
      },
    });
  };

  const filterConfig = [
    {
      id: 'code',
      name: 'code',
      label: 'Coupon Code',
      type: 'text',
    },
    {
      id: 'bookingFor',
      name: 'bookingFor',
      label: 'Service Type',
      type: 'select',
      options: [
        { label: 'Appointment', value: 'Appointment' },
        { label: 'DetoxRetreat', value: 'DetoxRetreat' },
        { label: 'Programme', value: 'Programme' },
        { label: 'Service', value: 'Service' },
        { label: 'Solution', value: 'Solution' },
        { label: 'Treatment', value: 'Treatment' },
      ],
    },
    {
      id: 'platformType',
      name: 'platformType',
      label: 'Platform Type',
      type: 'select',
      options: [
        { label: 'Website', value: 'website' },
        { label: 'Simulation', value: 'simulation' },
      ],
    },
    {
      id: 'type',
      name: 'type',
      label: 'Type',
      type: 'select',
      options: [
        { label: 'Percentage', value: 'percentage' },
        { label: 'Flat', value: 'Flat' },
      ],
    },
    {
      id: 'startDate',
      name: 'startDate',
      label: 'Start Date',
      type: 'date',
    },
    {
      id: 'expiryDate',
      name: 'expiryDate',
      label: 'Expiry Date',
      type: 'date',
    },
    {
      id: 'isActive',
      name: 'isActive',
      label: 'Status',
      type: 'select',
      options: [
        { label: 'Active', value: 'true' },
        { label: 'Inactive', value: 'false' },
      ],
    },
  ];

  // fetchData function for AdvancedTable
  const fetchData = useCallback(async (tableParams) => {
    const { page: tablePage, perPage, search, sortField, sortOrder: tableSortOrder, filters } = tableParams;

    // Parse URL params inside the function to avoid dependency loop
    const urlParams = queryString.parse(window.location.search);

    // Map filters to query params
    const codeFilter = filters?.code || urlParams.code || '';
    const bookingForFilter = filters?.bookingFor || urlParams.bookingFor || '';
    const platformTypeFilter = filters?.platformType || urlParams.platformType || '';
    const typeFilter = filters?.type || urlParams.type || '';
    const isActiveFilter = filters?.isActive !== undefined ? filters.isActive : urlParams.isActive || '';

    let startDateFilter = filters?.startDate || urlParams.startDate || '';
    let expiryDateFilter = filters?.expiryDate || urlParams.expiryDate || '';

    // Format dates to YYYY-MM-DD
    if (startDateFilter) startDateFilter = dayjs(startDateFilter).format('YYYY-MM-DD');
    if (expiryDateFilter) expiryDateFilter = dayjs(expiryDateFilter).format('YYYY-MM-DD');

    const newQuery = generateQueryString(
      ['page', tablePage || 1],
      ['perPage', perPage || 10],
      ['search', search || ''],
      ['sort', tableSortOrder || ''],
      ['sortOn', sortField || ''],
      ['code', codeFilter],
      ['bookingFor', bookingForFilter],
      ['platformType', platformTypeFilter],
      ['type', typeFilter],
      ['startDate', startDateFilter],
      ['expiryDate', expiryDateFilter],
      ['isActive', isActiveFilter]
    );

    return new Promise((resolve) => {
      dispatch(ActionGetAllCouponList(
        { Query: newQuery },
        (responseData, error) => {
          if (error) {
            resolve({ data: [], total: 0 });
            return;
          }
          resolve({
            data: responseData?.[0]?.docs || [],
            total: responseData?.[0]?.totalDocs || 0
          });
        }
      ));
    });
  }, [dispatch]);

  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/coupon-management">Coupon</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Coupon List</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table show-entire">
                    <div className="card-body">
                      {/* Table Header */}
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>Coupon List</h3>
                              <div className="doctor-search-blk">
                                <div className="add-group">
                                  {canCreate && (
                                    <Link
                                      to="/coupon-management/add-coupon"
                                      className="btn btn-primary add-pluss ms-2"
                                    >
                                      <img src={plusicon} alt="#" />
                                    </Link>
                                  )}

                                  <Link
                                    onClick={() => window.location.reload()}
                                    className="btn btn-primary doctor-refresh ms-2"
                                  >
                                    <img src={refreshicon} alt="#" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /Table Header */}
                      <AdvancedTable
                        resource="coupon"
                        columns={columns}
                        fetchData={fetchData}
                        filterConfig={filterConfig}
                        loading={loader}
                        enableSearch={false}
                        enableFilters={true}
                        enableExport={false}
                        enableRefresh={false}
                        enableColumnManager={false}
                        enableBulkActions={false}
                        enableSummary={false}
                        enableSelection={false}
                        persistState={true}
                        defaultPageSize={10}
                        onRowClick={(record) => {
                          // Optional: handle row click
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default CouponManagement;